import { useMotionValueEvent, useScroll } from "framer-motion";
import { useRef, useState } from "react";
export const useScrollVisibility = function() {
    let { mode ="direction" , topThreshold , downThreshold =50 , upThreshold =30 , initialVisible =true , lockDuration =200  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const effectiveTopThreshold = topThreshold !== null && topThreshold !== void 0 ? topThreshold : mode === "top" ? 10 : 0;
    const [isVisible, setIsVisible] = useState(initialVisible);
    const isVisibleRef = useRef(initialVisible);
    // 상태 변경 시점을 기록하여 단기간 내 중복 변경 방지
    const lastChangeTime = useRef(0);
    const lastScrollY = useRef(0);
    const lastDirection = useRef(null);
    const pivotScrollY = useRef(0);
    const { scrollY  } = useScroll();
    const setVisible = (visible)=>{
        isVisibleRef.current = visible;
        setIsVisible(visible);
        lastChangeTime.current = Date.now() // 변경 시각 기록
        ;
    };
    useMotionValueEvent(scrollY, "change", (currentScrollY)=>{
        // 0. 바운스 및 잠금 시간 체크
        // 상태 변경 직후(lockDuration 내)에는 스크롤 튐 현상이 있을 수 있으므로 무시
        if (currentScrollY < 0 || Date.now() - lastChangeTime.current < lockDuration) {
            lastScrollY.current = currentScrollY // 무시하는 동안에도 위치는 계속 최신화
            ;
            return;
        }
        // 1. Top 모드
        if (mode === "top") {
            const shouldShow = currentScrollY < effectiveTopThreshold;
            if (isVisibleRef.current !== shouldShow) {
                setVisible(shouldShow);
            }
            lastScrollY.current = currentScrollY;
            return;
        }
        // 2. Direction 모드
        // 2-1. 상단 강제 표시
        if (topThreshold !== undefined && currentScrollY < topThreshold) {
            if (!isVisibleRef.current) {
                setVisible(true);
            }
            pivotScrollY.current = currentScrollY;
            lastDirection.current = null;
            lastScrollY.current = currentScrollY;
            return;
        }
        // 2-2. 방향 감지 (노이즈 필터링 유지)
        const diff = currentScrollY - lastScrollY.current;
        if (Math.abs(diff) < 1) return;
        const direction = diff > 0 ? "down" : "up";
        if (direction !== lastDirection.current) {
            pivotScrollY.current = currentScrollY;
            lastDirection.current = direction;
        }
        // 2-3. 상태 변경
        const moveDistance = Math.abs(currentScrollY - pivotScrollY.current);
        if (direction === "down" && isVisibleRef.current && moveDistance > downThreshold) {
            setVisible(false);
            pivotScrollY.current = currentScrollY;
        } else if (direction === "up" && !isVisibleRef.current && moveDistance > upThreshold) {
            setVisible(true);
            pivotScrollY.current = currentScrollY;
        }
        lastScrollY.current = currentScrollY;
    });
    return isVisible;
};
